// extracted by mini-css-extract-plugin
module.exports = {"Layout":"cOV6jW"};